import React, { useState } from "react";
import DefaultButton from "../../components/DefaultButton/DefaultButton";
import DefaultModal from "../../components/DefaultModal/DefaultModal";

const DraftSessionActions = ({
  onSave,
  onDiscard,
  className = "",
  buttonSize = "small",
  saveDisabled = false,
  discardModalTitle = "Descartar registro",
  discardModalMessage = "Todas as alterações serão perdidas. Deseja descartar este registro?",
  discardConfirmLabel = "Descartar",
}) => {
  const [showDiscardModal, setShowDiscardModal] = useState(false);

  return (
    <>
      <div className={className}>
        <DefaultButton
          title="Descartar"
          type="secondary"
          onClick={() => setShowDiscardModal(true)}
          {...(buttonSize ? { size: buttonSize } : {})}
        />
        <DefaultButton
          title="Salvar"
          type="primary"
          onClick={onSave}
          disabled={saveDisabled}
          {...(buttonSize ? { size: buttonSize } : {})}
        />
      </div>

      <DefaultModal
        title={discardModalTitle}
        showModal={showDiscardModal}
        onClose={() => setShowDiscardModal(false)}
      >
        <div className="anthropometry-screen__confirm">
          <p>{discardModalMessage}</p>
          <div className="anthropometry-screen__confirm__actions">
            <DefaultButton
              title="Voltar"
              type="secondary"
              onClick={() => setShowDiscardModal(false)}
            />
            <DefaultButton
              title={discardConfirmLabel}
              type="primary"
              onClick={() => {
                setShowDiscardModal(false);
                onDiscard();
              }}
            />
          </div>
        </div>
      </DefaultModal>
    </>
  );
};

export default DraftSessionActions;
